/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on("keydown", "form.Cart input", function(event) {
    if (event.which === 13) {
        event.preventDefault();
        return false;
    }
});

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on("keydown", "form.Cart input", function(event) {
    if (event.which === 13) {
        event.preventDefault();
        return false;
    }
});

/**
 * sample Voice accordion
 *
 */
$(function(){
    if($('.SampleVoice__Wrapper').length == 0) return;

    const threshold_num = 5;
    const close_text = (location.href.indexOf('/zh') != -1) ? '隐藏' : 'close';
    const more_text = (location.href.indexOf('/zh') != -1) ? '试听' : 'more';

    if($('.SampleVoice__Wrapper').children().length > threshold_num){
        $('.SampleVoice__Inner').hide();
    }

    $('.js-morebtn').on('click', function() {
        $('.SampleVoice__Inner').slideToggle();
        $(this).toggleClass('is-active');

        if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded', true);
            $(this).find('.text').text(close_text);
        }else{
            $(this).attr('aria-expanded', false);
            $(this).find('.text').text(more_text);
        }
    });
});



/**
 * SPサイズの際にImage--lazyLoadが付与されない問題
 *
 */
(()=>{
    const boxes = document.querySelectorAll(".Image--lazyLoad");

    const options = {
    root: null,
    rootMargin: "-25% 0px",
    threshold: 0
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);

    boxes.forEach(box => {
        if(window.innerWidth < 768){
            observer.observe(box);
        }
    });

    /**
     * 交差したときに呼び出す関数
     * @param entries
     */
    function doWhenIntersect(entries) {
    // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                activateIndex(entry.target);
            }
        });
    }

    /**
     *  Image--lazyLoadedを追加
     * @param {*} element
     */
    function activateIndex(element) {
        element.classList.add("Image--lazyLoaded");
    }

})();

/**
 * Collection page Accordion
 *
 */
const mediaQueryList = window.matchMedia('(max-width: 750px)');


const listener = (event) => {

    // リサイズ時に行う処理
    if (event.matches) {
        // 768px以下
        // console.log('SP用ブレークポイント用処理');
        $('.Collection__socialLinkListWrapper').hide();

    } else {
        // 768px以上
        // console.log('PC用ブレークポイント用処理');
        $('.Collection__socialLinkListWrapper').show();
        $('.Collection__profileInner').removeClass('is-open');
        $('.toggle_Collection_profile').removeClass('is-active');

    }
};


mediaQueryList.addEventListener("change", listener);

listener(mediaQueryList);

$('.toggle_Collection_profile').on('click',function(){
    // if(window.innerWidth > 750) return;
    if(!mediaQueryList.matches) return;
    $(this).toggleClass('is-active');
    $('.Collection__profileInner').toggleClass('is-open');
    $('.Collection__socialLinkListWrapper').slideToggle();
})

// $(function(){
//     if(window.innerWidth <= 750 && $('.toggle_Collection_profile').text().length > 0) {

//         $('.Collection__socialLinkListWrapper').hide();
//         // $('.Collection__profileInner p').hide();
//         // $('.Collection__profileInner p').eq(0).show();
//     }

//     $('.toggle_Collection_profile').on('click',function(){
//         if(window.innerWidth > 750) return;
//         $(this).toggleClass('is-active');
//         $('.Collection__profileInner').toggleClass('is-open');
//         // $('.Collection__profileInner p').each(function(index){
//         //     if(index == 0) return;
//         //     $(this).slideToggle();
//         // });
//         $('.Collection__socialLinkListWrapper').slideToggle();
//     })

// });

// let windowWidth = window.innerWidth;



// $(window).on('resize',function(){

//     if(window.innerWidth == windowWidth) return;
//     if($('.Collection__profileInner').text().length == 0) return;

//     windowWidth = window.innerWidth;

//     console.log({windowWidth})

//     if(window.innerWidth > 750){
//         $('.Collection__socialLinkListWrapper').show();
//         // $('.Collection__profileInner p').show();
//         $('.Collection__profileInner').removeClass('is-open');
//         $('.toggle_Collection_profile').removeClass('is-active');

//     }else{
//         if(!$('.toggle_Collection_profile').hasClass('is-active')){
//             $('.Collection__socialLinkListWrapper').hide();
//             // $('.Collection__profileInner p').hide();
//             // $('.Collection__profileInner p').eq(0).show();
//             $('.toggle_Collection_profile').removeClass('is-active');
//         }
//     }
// });

// $(function(){

//     if($('.js-sellingform').length == 0) return;

//   const submitButton = $('.js-sellingform [type="submit"]');

//   submitButton.prop('disabled', true);

//     $('#policy').on('change', function(){
//         if($(this).prop('checked')){
//             $('.Form__policyerror').hide();
//           submitButton.prop('disabled', false);

//         }else{
//           submitButton.prop('disabled', true);
//            $('.Form__policyerror').show();
//         }
//     });

//     $('form.js-sellingform').on('submit', function(e){

//        e.preventDefault();

//       if(!$('#policy').prop('checked')){
//             console.log('not checked');

//              $('.Form__policyerror').show();
//             return false;
//         }
//           // return false;
//         // if($('#policy').prop('checked')){
//         //     $('.Form__policyerror').hide();
//         //     return true;
//         // }else{
//         //     console.log('not checked');
//         //     $('.Form__policyerror').show();
//         //     return false;
//         // }

//     });
// })

/**
 * Selling form
 *
 */

// $(function(){

//     if($('.js-sellingform').length == 0) return;

//     $('#policy').on('change', function(){
//         if($(this).prop('checked')){
//             $('.Form__policyerror').hide();
//         }
//     });

//     $('.js-sellingform').on('submit', function(){
//         if($('#policy').prop('checked')){
//             $('.Form__policyerror').hide();
//             return true;
//         }else{
//             console.log('not checked');
//             $('.Form__policyerror').show();
//             return false;
//         }

//     });
// })

$(function() {

    const form = $('.js-sellingform');
    if(form.length == 0) return;

    let checkPolicy = false;


    // チェックボックスの状態変更時にボタンの活性状態を更新
    $('#policy').on('change', function() {
        if ($(this).prop('checked')) {
            $('#submit_button').prop('disabled', false);  // ボタンを活性化
            // $('#overlay').hide();  // オーバーレイを隠す
            $('.Form__policyerror').hide();  // エラーメッセージを隠す
            checkPolicy = true;
        } else {
            $('#submit_button').prop('disabled', true);  // ボタンを非活性化
            // $('#overlay').show();  // オーバーレイを表示
            $('.Form__policyerror').hide();  // エラーメッセージを隠す
            checkPolicy = false;
        }
    });

    const checkNames = ['公式HP URL','YouTube', 'BOOTH', 'SNS' ];

    let checkFlg = false
    form.on('change', function(){
        checkFlg = false;
        checkNames.forEach(function(name){
            $('.Form__checkerror').hide();
            // nameが含まれているInputのvalueが空でない場合
            if($(`input[name*="${name}"]`).val() != ''){
                checkFlg = true;

            }
        });

        if(checkFlg &&  checkPolicy){
            $('#submit_button').prop('disabled', false);
            $('#overlay').hide();
        }else{
            $('#submit_button').prop('disabled', true);
            $('#overlay').show();  // オーバーレイを表示
        }

    });

    // オーバーレイがクリックされた時のイベントハンドラ
    $('#overlay').on('click', function() {
        if($('#policy').prop('checked') == false){
            $('.Form__policyerror').show();  // エラーメッセージを表示
        }
        if(checkFlg == false){
            $('.Form__checkerror').show();  // エラーメッセージを表示
            checkNames.forEach(function(name){
                $(`input[name*="${name}"]`).addClass('is-error');
            });
        }else{
            $('.Form__checkerror').hide();
            checkNames.forEach(function(name){
                $(`input[name*="${name}"]`).removeClass('is-error');
            });
        }
    });

});

  // GLOBAL-E セレクター
$('.shopify-localization-form select').on('change', function() {
    document.cookie = 'locale_popup=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    $(this).closest('form').submit();
});

$(function(){
    $(document).on('click', '.js-deleteCart', function() {
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')  // CSRFトークンを追加
            },
            success: function() {
                window.location.reload();
            }
        });
    });

})

$(function(){
    $(document).on('click', '.js-deleteCartDrawer', function() {
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')  // CSRFトークンを追加
            },
            success: function() {
                fetch(window.routes.cartUrl + '?view=drawer' + '&timestamp=' + Date.now(), {
                    credentials: 'same-origin',
                    method: 'GET'
                }).then(function (content) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                });
            }
        });
    });

});

$(function() {
    if($('.countryPopup').length == 0) return;
    const localization = getLocalizationCookie();
    if(document.cookie.indexOf('locale_popup') != -1){
        $('.countryPopup').hide();
        return;
    }
    if(countryArray.includes(localization)){
        $('.countryPopup').show();
        document.cookie = 'locale_popup=true; path=/';
    }
    $('.js-closePopup').on('click', function() {
        $('.countryPopup').hide();
    });

    $('body').on('click', function(event) {
        if (!$(event.target).closest('.countryPopup').length) {
            $('.countryPopup').hide();
        }
    });

    function getCookieByPath(name, path = '/') {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());

    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name && document.location.pathname.startsWith(path)) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

function getLocalizationCookie() {
    const url = window.location.href;
    const containsZh = url.includes('/zh/');
    const localization = containsZh ? getCookieByPath('localization', '/zh') : getCookieByPath('localization');
  return localization;
}
});


$(window).on('scroll', function() {
  if ($(this).scrollTop() > 0) {
    $('body').addClass('is-scrolled');
  } else {
    $('body').removeClass('is-scrolled');
  }
});
